export const IMPORTED_PATIENT = 'imported_patient';
export const INTEGRATION = 'integration';

export const CONFIGURATION_TYPE_OPTS = [
  { label: 'File', value: IMPORTED_PATIENT },
  { label: 'Integration', value: INTEGRATION },
];

// The System a client's integration import configuration is written against.
//
// NOTE this vocabulary is NOT the client's integration-type list: it says `matrixcare`
// where that says `matrix`, and has no `kno2` at all. They overlap without being the
// same thing, so keep the values as they are rather than "tidying" them into agreement.
//
// `hospitaldischarge` (OLIO-3517) matches the integration type of the same name, and
// carries the group-mapping crosswalk for senders that have no EMR of their own — the
// HTTPS path (Sentara). Epic clients keep using `epic`.
export const PLATFORM_OPTS = [
  { label: 'Epic', value: 'epic' },
  { label: 'Hospital Discharge', value: 'hospitaldischarge' },
  { label: 'MatrixCare', value: 'matrixcare' },
  { label: 'PCC', value: 'pcc' },
];

// The Systems whose import configuration carries GROUP MAPPINGS (`config.lookups.groups`) — the
// crosswalk that turns a name the system sends into an Olio group. Epic has always had it; the
// hospital-discharge path needs exactly the same thing, since a sender arriving over HTTPS names
// its facilities the same way and routing fails identically without it. PCC and MatrixCare use it
// for the hospital an admission came from (OLIO-3579): olio-api resolves that name through these
// mappings to fill in Transferred From (OLIO-3524), so a name that doesn't match a hospital
// exactly needs a mapping here.
export const GROUP_MAPPING_PLATFORMS = ['epic', 'hospitaldischarge', 'pcc', 'matrixcare'];

export const hasGroupMappings = (platform: string | null | undefined): boolean =>
  GROUP_MAPPING_PLATFORMS.includes(platform ?? '');

export const DELIMITER_OPTS = [
  { label: 'Comma Separated', value: ',' },
  { label: 'Pipe Separated', value: '|' },
  { label: 'Tab Separated', value: '\t' },
];

export type PatientMappingKey =
  | 'name'
  | 'externalId'
  | 'dateOfBirth'
  | 'sex'
  | 'hospitalAdmissionDate'
  | 'providerAdmissionDate'
  | 'address1'
  | 'address2'
  | 'city'
  | 'state'
  | 'zip'
  | 'phoneNumber';

export const PATIENT_MAPPINGS: { label: string; key: PatientMappingKey; optional?: boolean }[] = [
  { label: 'Patient Name', key: 'name' },
  { label: 'Patient ID', key: 'externalId' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Gender', key: 'sex' },
  { label: 'Hospital Admission Date', key: 'hospitalAdmissionDate', optional: true },
  { label: 'Network Provider Admission Date', key: 'providerAdmissionDate', optional: true },
  { label: 'Address 1', key: 'address1', optional: true },
  { label: 'Address 2', key: 'address2', optional: true },
  { label: 'City', key: 'city', optional: true },
  { label: 'State', key: 'state', optional: true },
  { label: 'Zip', key: 'zip', optional: true },
  { label: 'Phone Number', key: 'phoneNumber', optional: true },
];
